import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class StpService {
  constructor(private http: HttpClientService) {}

  public createReceivingPayments(): Observable<any> {
    return this.http
      .get("/api/stp/create_receiving_payments")
      .pipe(tap((_) => console.log("StpService.createReceivingPayments: Ok.")));
  }

  public allStpAccountsByPerson(person_id: string): Observable<any> {
    const options = {
      params: {
        id: person_id,
      },
    };
    return this.http
      .get(`/api/persons/${person_id}/stp_accounts`)
      .pipe(tap((_) => console.log("StpService.allStpAccountsByPerson: Ok.")));
  }

  public swapStpAccount(account_old: number | string, account_new: number | string): Observable<any> {
    const options = {
      old_account_id: account_old,
      new_account_id: account_new,
    };
    return this.http
      .put("/api/stp/swap_stp_account/", options)
      .pipe(tap((_) => console.log("StpService.swapStpAccount: Ok.")));
  }

  public createRelatedTransaction(stp_transaction_id): Observable<any> {
    return this.http
      .post("/api/stp/" + stp_transaction_id + "/create_related_transaction", {})
      .pipe(tap((_) => console.log("ApplicationsService.createRelatedTransaction: Ok")));
  }
}
